import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'
import colors from 'vuetify/es5/util/colors';

Vue.use(Vuetify, {
  theme: {
    // primary: '#ee44aa',
    // secondary: '#424242',
    // accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107',
    primary: colors.orange.darken1, // #E53935
    secondary: colors.orange.lighten4, // #FFCDD2
    accent: colors.deepOrange.base, // #3F51B5
    accentDark: colors.deepOrange.darken3,
  },
  customProperties: true,
  iconfont: 'md',
})
